export enum DesignEditorMode {
  ORDER_ITEM_CREATION = 'order_item_creation',
  PRODUCT_CREATION = 'product_creation',
  PRODUCT_EDITING = 'product_editing',
  PRODUCT_EXPANSION_PRODUCT_EDITING = 'product_expansion_product_editing',
  PRODUCT_VARIANT_CONNECTION = 'product_variant_connection',
  PRODUCT_VARIANT_EDITING = 'product_variant_editing',
  MOCKUP = 'mockup',
}
